<template>
  <div class="login-page">
    <!-- 左侧品牌区 -->
    <aside class="brand-side">
      <div class="brand-deco">
        <div class="blob blob-1"></div>
        <div class="blob blob-2"></div>
        <div class="blob blob-3"></div>
        <svg class="grid-lines" viewBox="0 0 600 800" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,160 Q150,120 300,160 T600,160" stroke="rgba(255,255,255,0.08)" stroke-width="1" fill="none"/>
          <path d="M0,260 Q150,220 300,260 T600,260" stroke="rgba(255,255,255,0.06)" stroke-width="1" fill="none"/>
          <path d="M0,360 Q150,320 300,360 T600,360" stroke="rgba(255,255,255,0.05)" stroke-width="1" fill="none"/>
        </svg>
      </div>

      <div class="brand-content">
        <div class="brand-mark">
          <div class="mark-icon">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 6C13.5 6 8 14 8 22c0 9 7 16 16 20 9-4 16-11 16-20 0-8-5.5-16-16-16z" fill="rgba(255,255,255,0.16)" stroke="#fff" stroke-width="1.6"/>
              <path d="M16 24h4l2-5 4 10 2-5h4" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="mark-text">
            <div class="mark-cn">脉钥健康</div>
            <div class="mark-en">MAIYUE HEALTH</div>
          </div>
        </div>

        <h1 class="brand-title">
          健康商城<br/>管理平台
        </h1>
        <p class="brand-tagline">
          融合药食同源养生与舌面像智能检测<br/>
          让健康管理 · 更专业 · 更日常
        </p>

        <ul class="brand-features">
          <li><span class="dot"></span>药食同源健康产品 · 全链路上架管理</li>
          <li><span class="dot"></span>舌象 / 面象 AI 健康检测与体质分析</li>
          <li><span class="dot"></span>订单 · 用户 · 内容一体化运营后台</li>
        </ul>
      </div>

      <div class="brand-footer">© {{ year }} 脉钥健康 · 健康商城管理平台</div>
    </aside>

    <!-- 右侧表单区 -->
    <main class="form-side">
      <div class="form-card">
        <header class="form-head">
          <div class="welcome">欢迎登录</div>
          <div class="welcome-sub">健康商城管理平台 · 请输入您的账号信息</div>
        </header>

        <el-form
          :model="loginForm"
          :rules="rules"
          ref="loginFormRef"
          class="login-form"
          @keyup.enter="submitForm"
        >
          <el-form-item prop="userName">
            <label class="field-label">账号</label>
            <el-input
              v-model="loginForm.userName"
              placeholder="请输入用户名"
              size="large"
              :prefix-icon="UserIcon"
              clearable
            />
          </el-form-item>

          <el-form-item prop="passWord">
            <label class="field-label">密码</label>
            <el-input
              v-model="loginForm.passWord"
              type="password"
              placeholder="请输入登录密码"
              size="large"
              :prefix-icon="LockIcon"
              show-password
            />
          </el-form-item>

          <div class="form-row">
            <el-checkbox v-model="loginForm.remember">记住密码</el-checkbox>
            <span class="link" @click="forgetPassword">忘记密码？</span>
          </div>

          <el-button
            class="submit-btn"
            type="primary"
            size="large"
            :loading="loading"
            @click="submitForm"
          >登 录</el-button>

          <div class="form-bottom">
            没有账号？<span class="link strong" @click="register">立即注册</span>
          </div>
        </el-form>
      </div>
    </main>
  </div>
</template>

<script>
  import { User, Lock } from '@element-plus/icons-vue'
  import { markRaw } from 'vue'
  const Base64 = require('js-base64').Base64

  export default {
    data() {
      return {
        UserIcon: markRaw(User),
        LockIcon: markRaw(Lock),
        loading: false,
        year: new Date().getFullYear(),
        loginForm: {
          userName: '',
          passWord: '',
          remember: true,
        },
        rules: {
          userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          passWord: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        },
      }
    },

    methods: {
      submitForm() {
        this.$refs.loginFormRef.validate(valid => {
          if (valid) this.onSubmit()
        })
      },
      onSubmit() {
        this.loading = true
        this.$applicationJson('/business/user/login', {
          username: this.loginForm.userName,
          password: this.loginForm.passWord,
        }).then(res => {
          this.loading = false
          if (res.data.code == 0) {
            this.setCookie('token', res.data.data.token)
            sessionStorage.setItem('isLogin', true)
            sessionStorage.setItem('token', res.data.data.token)
            localStorage.setItem('token', res.data.data.token)
            localStorage.setItem('loginInfo', JSON.stringify(res.data.data))
            localStorage.setItem('tabActiveIndex', 0)
            sessionStorage.setItem('currentLeftMenuIndex', 0)
            this.$store.commit('changeLogin', { token: res.data.data.token })
            this.$router.replace({ path: '/mallManagement/dashboard' })
            this.setUserInfo()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.loading = false
          this.$message.error('网络异常')
        })
      },
      register() {
        this.$router.push('/register/register')
      },
      forgetPassword() {
        this.$router.push('/forgetPassword/forgetPassword')
      },
      setUserInfo() {
        if (this.loginForm.remember) {
          localStorage.setItem('userName', this.loginForm.userName)
          localStorage.setItem('passWord', Base64.encode(this.loginForm.passWord))
        } else {
          localStorage.setItem('userName', '')
          localStorage.setItem('passWord', '')
        }
      },
      setCookie(cName, value, expiredays) {
        const exdate = new Date()
        exdate.setDate(exdate.getDate() + expiredays)
        document.cookie = cName + '=' + decodeURIComponent(value) +
          ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
      },
    },

    created() {
      this.$nextTick(() => {
        localStorage.setItem('tabActiveIndex', 0)
        localStorage.removeItem('loginInfo')
        const userName = localStorage.getItem('userName')
        if (userName) {
          this.loginForm.userName = userName
          const pw = localStorage.getItem('passWord')
          this.loginForm.passWord = pw ? Base64.decode(pw) : ''
          this.loginForm.remember = true
        } else {
          this.loginForm.remember = false
        }
      })
    },
  }
</script>

<style lang="less" scoped>
  // ── Design Tokens（取自 docs/design-tokens/tokens.less，本页内联） ──
  @primary-50:  #E6F7F5;
  @primary-100: #C2EDE7;
  @primary-300: #5CCABD;
  @primary-500: #2EAD9E;
  @primary-600: #258F83;
  @primary-700: #1D7268;
  @primary-800: #15544D;

  @gray-0:   #FFFFFF;
  @gray-50:  #FAFAF8;
  @gray-100: #F4F3F0;
  @gray-200: #E8E6E1;
  @gray-400: #B0ADA6;
  @gray-500: #8A8780;
  @gray-700: #4D4A43;
  @gray-800: #33312B;

  @font-display: 'Noto Serif SC', 'SimSun', serif;
  @font-body:    'Noto Sans SC', 'Microsoft YaHei', sans-serif;

  .login-page {
    position: absolute;
    inset: 0;
    display: flex;
    background: @gray-50;
    font-family: @font-body;
    color: @gray-800;
    overflow: hidden;
  }

  /* ─────── 左侧品牌区 ─────── */
  .brand-side {
    flex: 1.05;
    position: relative;
    padding: 56px 64px;
    background:
      radial-gradient(120% 80% at 0% 0%, rgba(255,255,255,0.08), transparent 60%),
      linear-gradient(135deg, @primary-600 0%, @primary-700 55%, @primary-800 100%);
    color: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 480px;
  }

  .brand-deco {
    position: absolute;
    inset: 0;
    pointer-events: none;
    .blob {
      position: absolute;
      border-radius: 50%;
      filter: blur(40px);
      opacity: 0.55;
    }
    .blob-1 {
      width: 360px; height: 360px;
      top: -120px; right: -100px;
      background: radial-gradient(circle, rgba(94, 218, 200, 0.45), transparent 70%);
    }
    .blob-2 {
      width: 280px; height: 280px;
      bottom: -80px; left: -60px;
      background: radial-gradient(circle, rgba(46, 173, 158, 0.5), transparent 70%);
    }
    .blob-3 {
      width: 200px; height: 200px;
      top: 50%; right: 20%;
      background: radial-gradient(circle, rgba(255, 230, 160, 0.18), transparent 70%);
    }
    .grid-lines {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
    }
  }

  .brand-content {
    position: relative;
    z-index: 1;
  }

  .brand-mark {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 64px;

    .mark-icon {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg { width: 100%; height: 100%; }
    }
    .mark-text {
      .mark-cn {
        font-family: @font-display;
        font-size: 22px;
        font-weight: 600;
        letter-spacing: 4px;
      }
      .mark-en {
        font-size: 10px;
        letter-spacing: 2px;
        opacity: 0.7;
        margin-top: 2px;
      }
    }
  }

  .brand-title {
    font-family: @font-display;
    font-size: 56px;
    font-weight: 600;
    line-height: 1.18;
    letter-spacing: 6px;
    margin: 0 0 28px;
    color: #fff;
  }

  .brand-tagline {
    font-size: 15px;
    line-height: 1.9;
    letter-spacing: 1px;
    margin: 0 0 48px;
    color: rgba(255,255,255,0.78);
    max-width: 420px;
  }

  .brand-features {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 0;
      font-size: 14px;
      color: rgba(255,255,255,0.86);
      letter-spacing: 0.5px;
      .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: @primary-300;
        box-shadow: 0 0 0 4px rgba(92, 202, 189, 0.18);
      }
    }
  }

  .brand-footer {
    position: relative;
    z-index: 1;
    font-size: 12px;
    color: rgba(255,255,255,0.5);
    letter-spacing: 1px;
  }

  /* ─────── 右侧表单区 ─────── */
  .form-side {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    background: @gray-50;
  }

  .form-card {
    width: 100%;
    max-width: 420px;
  }

  .form-head {
    margin-bottom: 36px;
    .welcome {
      font-family: @font-display;
      font-size: 32px;
      font-weight: 600;
      color: @gray-800;
      letter-spacing: 2px;
    }
    .welcome-sub {
      margin-top: 8px;
      font-size: 13px;
      color: @gray-500;
      letter-spacing: 0.5px;
    }
  }

  .login-form {
    .field-label {
      display: block;
      font-size: 12px;
      color: @gray-500;
      margin-bottom: 8px;
      letter-spacing: 1px;
      font-weight: 500;
    }

    :deep(.el-form-item) {
      margin-bottom: 22px;
    }

    :deep(.el-input__wrapper) {
      background: @gray-0;
      border-radius: 10px;
      box-shadow: 0 0 0 1px @gray-200 inset;
      transition: box-shadow 200ms ease;
      padding: 4px 14px;
      &:hover {
        box-shadow: 0 0 0 1px @primary-300 inset;
      }
      &.is-focus {
        box-shadow: 0 0 0 1.5px @primary-500 inset, 0 0 0 4px @primary-50;
      }
    }
    :deep(.el-input__inner) {
      height: 44px;
      font-size: 14px;
      color: @gray-800;
      &::placeholder { color: @gray-400; }
    }
    :deep(.el-input__prefix-inner) {
      color: @gray-400;
      font-size: 16px;
      margin-right: 6px;
    }

    .form-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 4px 0 24px;
      :deep(.el-checkbox__label) {
        font-size: 13px;
        color: @gray-700;
      }
      :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
        background: @primary-500;
        border-color: @primary-500;
      }
      :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
        color: @gray-700;
      }
    }

    .submit-btn {
      width: 100%;
      height: 48px;
      border-radius: 10px;
      font-size: 15px;
      letter-spacing: 8px;
      font-weight: 500;
      background: linear-gradient(135deg, @primary-500, @primary-600);
      border: none;
      box-shadow: 0 6px 20px rgba(46, 173, 158, 0.32);
      transition: transform 200ms ease, box-shadow 200ms ease;
      &:hover {
        background: linear-gradient(135deg, @primary-500, @primary-700);
        box-shadow: 0 10px 28px rgba(46, 173, 158, 0.38);
        transform: translateY(-1px);
      }
      &:active {
        transform: translateY(0);
      }
    }

    .form-bottom {
      margin-top: 22px;
      text-align: center;
      font-size: 13px;
      color: @gray-500;
    }

    .link {
      cursor: pointer;
      color: @primary-600;
      font-size: 13px;
      transition: color 150ms ease;
      &:hover { color: @primary-700; }
      &.strong { font-weight: 600; }
    }
  }

  /* ─────── 响应式 ─────── */
  @media (max-width: 1024px) {
    .brand-side {
      padding: 40px 36px;
      min-width: 360px;
    }
    .brand-title { font-size: 44px; }
  }

  @media (max-width: 860px) {
    .brand-side { display: none; }
    .form-side { padding: 24px; }
  }
</style>
